var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"new-card\" ng-class=\"{'card-selected': $ctrl.active}\">\n<div class=\"flex flex-row flex-space-between full-width\">\n<div class=\"card-info-icon\" ng-click=\"$ctrl.onInfoClicked($event)\" ng-if=\"$ctrl.showInfo\">\n<span class=\"icon icon-18 icon-i\"></span>\n</div>\n<div class=\"card-icon flex flex-center-off-axis flex-center-on-axis\">\n<div class=\"icon icon-32 icon-mobile-18\" ng-class=\"$ctrl.icon\"></div>\n</div>\n<div class=\"flex flex-column card-main-content flex-center-off-axis\">\n<div class=\"card-heading\">\n{{:: $ctrl.title }}\n</div>\n<div class=\"card-content\">\n{{:: $ctrl.subtitle }}\n</div>\n</div>\n</div>\n</div>\n";
var id1="app/reservation/selections/general-card.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/reservation/selections/general-card.tpl.html
// module id = 133
// module chunks = 1 2